const actionTypes = {
    SET_INITIAL_BEAUTY_PREFERENCES: 'SET_INITIAL_BEAUTY_PREFERENCES',
    SET_MULTIPLE_BEAUTY_PREFERENCES: 'SET_MULTIPLE_BEAUTY_PREFERENCES',
    CLEAR_BEAUTY_PREFERENCE: 'CLEAR_BEAUTY_PREFERENCE',
    SET_COLOR_IQ: 'SET_COLOR_IQ',
    SET_EXPANDED_PREFERENCE: 'SET_EXPANDED_PREFERENCE',
    SET_PROFILE_COMPLETION_PERCENTAGE: 'SET_PROFILE_COMPLETION_PERCENTAGE',
    SET_MAPPED_BRANDS_LIST: 'SET_MAPPED_BRANDS_LIST'
};

module.exports = actionTypes;
